module.exports = __webpack_public_path__ + "static/img/t25.66dbf822.png";